import { app } from '../../app';
import { Controller } from './company.controller';

app.component('company', {
    bindings: {
        account: '<',
        companyId: '<',
        currentCompany: '<',
        licenseInfo: '<',
    },
    controller: Controller,
    templateUrl: require('./company.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/company.component.js